import { clsx } from "clsx";
import { forwardRef } from "react";

import { Loader } from "@/components/ui/status/Loader/Loader";
import { Typography } from "@/components/ui/text/Typography/Typography";

interface ButtonContentProps {
  text: string;
  isLoading?: boolean;
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  iconClassName?: string;
  hideText?: boolean;
  className?: string;
  smallText?: boolean;
}

export const ButtonContent = forwardRef<HTMLHeadingElement, ButtonContentProps>(
  ({ text, isLoading, icon: Icon, iconClassName = "h-6 w-6", hideText, className, smallText = false }, ref) => {
    let iconOrLoader = null;
    if (isLoading) {
      iconOrLoader = <Loader className={clsx("flex-shrink-0", iconClassName)} />;
    } else if (Icon) {
      iconOrLoader = <Icon className={clsx("flex-shrink-0", iconClassName)} />;
    }

    return (
      <>
        {iconOrLoader}
        {text && (
          <Typography
            size={smallText ? "labels-xs" : "labels-lg"}
            variant="prominent-2"
            className={clsx(
              `t:truncate hyphens-auto ${hideText ? "sr-only" : ""} font-secondary font-weight-500`,
              className,
            )}
            ref={ref}
          >
            {text}
          </Typography>
        )}
      </>
    );
  },
);
